import axios from "axios";
import IndexedDB from "../../../../../db/IndexedDB";
import IndexedDBAsync from "../../../../../db/IndexedDBAsync";
import schema from '../../../../../util/schema.json'
import { API_URL } from "../../../../../config/config";
import MachineVI from "../MachineVI";
import { NotificationManager } from 'react-notifications'
import parseCookies from '../../../../../util/parseCookies'
import moment from 'moment'


const parseFilter = () => {
    const data = parseCookies("loginFilter")
    const dbAsync = new IndexedDBAsync('dbV1', schema.schemas, 1)
    let locations = data.Locations.map((i) => +i).join(','),
        routes = data.Routes.map((i) => +i).join(',')
    return {
         Locations: locations
        ,Routes: routes
        ,Favourites: '0'
        ,Favourite: true
        ,LastVisited: false
        ,TopCount: 1
    }
}

const getMachine = (machineId) =>
    axios
        .post(`${API_URL}/api/mobile/FilteredMachines`, {...parseFilter(), Favourites:machineId})
        .then((res) => {
            return res.data
        })
        .catch((e) => console.error(e))

const getMachineProductsOnline = async (machineId) => {
    return axios
        .post(`${API_URL}/api/mobile/MachinesProducts`, {
            machineIds: [machineId],
        })
        .then((res) => {
            moment.locale('pl')
            return res.data
        })
        .catch((e) => console.error(e))
}
export const updateVisitData = async (db, machineId) => {
    return getMachine(machineId)
        .then(([machine]) => db.addOrPutItem('machines', machine, machineId))
        .then(() => db.deleteItem('visits', machineId))
        .then(() => getMachineProductsOnline(machineId))
        .then(products => {
            products.forEach((i) =>
                db
                    .addOrPutItem('machineProduct', i, i.MachineProductId)
                    .catch((e) => console.error(e))
            )
        })
}
const sendVis = (vi, db) => new Promise((res, rej) => {
    return -1;
    return db.getItem('machines', vi.MachineId)
        .then((machine) => {
            return axios.post(`${API_URL}/api/machine-vis/${vi.MachineId}`, {
                MachineId: vi.MachineId
                , MachineProducts: vi.Data
                , VisitId: vi.VisitId
                , MachineCreateDateTime: machine.createDateTime || Date.now(),
            })})
        .then(response => res(response.data))
        .catch(err => {
            console.log(err.response)
            rej(err.response)
        })
}) 

export const  updateMachineInfoAndRepeatSendingPendedVisits = async (machineId) => {
    await updateVisitData(machineId)
    return sendPendingVisits(machineId)
}
export default async function sendPendingVisits(machineId) {
    return -1;
    const db = new IndexedDB('dbV1', schema.schemas, 1)
    db.openDB()

    const asyncDb = new IndexedDBAsync('dbV1', schema.schemas, 1)
    await asyncDb.openDB()
    const visArr = []
    let transaction = await asyncDb.db.transaction(['visits'], 'readwrite')

    for await (const cursor of transaction.store) {
        if (machineId) {
            if (!cursor.value?.['pushed'] && cursor.value?.['MachineId'] === machineId) visArr.push(cursor.value)
        } else {
            if (!cursor.value?.['pushed']) visArr.push(cursor.value)
        }
        await cursor.continue()
    }

    let succeedVis
    if (navigator.onLine) {
        await Promise.all(visArr.map(i => sendVis(i, asyncDb)))
            .then(
                (value) => {
                    succeedVis = value?.map(i => i?.Data)
                },
                (reason) => {
                    if (Array.isArray(reason))
                        reason.forEach(i => NotificationManager.error(i.data?.message))
                    else {
                        if (reason.status === 426) {
                            console.error(426)
                            throw reason
                        }
                        NotificationManager.error(reason.data?.message)
                    }
                },
            )
    }

    return succeedVis && succeedVis.length && Array.isArray(succeedVis) && Promise.all(succeedVis.map(i => {
        asyncDb.getItem('visits', i.MachineId)
            .then(res => {
                res.Data.forEach(element => {
                    (async() => {
                        const income = element.income
                        if (income) {
                            delete (element.income)
                            await asyncDb.addOrPutItem('machineProduct', {
                                ...element,
                                LastItemCount: +element.LastItemCount + income,
                                AuthCode: element.AuthCode || null,
                            }, element.MachineProductId)
                        } else {
                            console.log('else await asyncDb.addOrPutItem(\'machineProduct\', {')
                            console.log({...element, AuthCode: element.AuthCode || null})
                            await asyncDb.addOrPutItem('machineProduct', {
                                ...element,
                                AuthCode: element.AuthCode || null,
                            }, element.MachineProductId)
                        }

                    })()
                })
            })
            .then(() =>
                asyncDb.deleteItem('visits', i.MachineId)
            )
            .then(() =>
                asyncDb.getItem('machines', i.MachineId)
            )
            .then(res => res && asyncDb.addOrPutItem('machines', {
                ...res,
                VisitId: i.NewVisitId,
                createDateTime: i.LastUpdateDateTime || Date.now(),
            }, i.MachineId))
            .then(() => NotificationManager.success(succeedVis.length === 1 ? `Wizyta została zapisana poprawnie` : `Wizyty zostały zapisane poprawnie` ))
    }))
        .then(
            () => succeedVis,
            reason => {
                console.error("reason:", reason)
                throw Error(reason)
            },
        )

    // asyncDb.
}